import { render, staticRenderFns } from "./Input_Textarea.vue?vue&type=template&id=c10201ea&scoped=true&"
import script from "./Input_Textarea.vue?vue&type=script&lang=js&"
export * from "./Input_Textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10201ea",
  null
  
)

export default component.exports